<template lang="html">
    <el-dialog class="dialog"
        :visible.sync="dialogVisiable"
        :show-close="true"
        :center="true"
        :before-close="closeDialog"
        :append-to-body="appendToDialog"
        :close-on-click-modal="false"
        custom-class="common-confirm-dialog"
        width="300px"
    >   
        <div>
            <i class="iconfont" :class="icon" :style="{color: iconColor}"></i>
        </div>
        <div class="common-confirm-info">
            <slot></slot>
        </div>
        <span slot="footer">
            <el-button type="primary" @click="handleConfirmOK">{{$t("btn.confirm")}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
  export default {
    props: {
        'dialogVisiable': {
            type: Boolean,
            required: true
        },
        'confirm': {
            type: Function,
            required: true
        },
        'cancel': {
            type: Function
        },
        'appendToDialog': {
            type: Boolean,
            default: false,
        },
        'icon': {
            type: String,
            default: 'icon-jingshi',
        },
        'iconColor': {
            type: String,
            default: '#FFC300'
        }
    },
    methods: {
        handleConfirmOK(){
            this.$emit('update:dialogVisiable', false)
            if(this.confirm){
                this.confirm();
            }
        },
        closeDialog(done) {
            // done(); //使用done会有js报错
            this.$emit('update:dialogVisiable', false)
            if(this.cancel){
                this.cancel();
            }
        }
    }
  };
</script>

<style lang="less" scoped>
.common-confirm-dialog {

    .iconfont{
        font-size: 53.33px;
        text-align: center;
        display: block;
        margin-top: 14px;
    }
    .common-confirm-info {
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        margin-top: 25px;
        margin-bottom: 15px;
    }
}
.tips-form-class .iconfont {
    display: none;
}
</style>


// WEBPACK FOOTER //
// CommonConfirm.vue?e3148550